<template>
  <div> 
    <div id="app">
      <Navbar @updateUser="updateUser" v-if="user.id" />
      <router-view @updateUser="updateUser" />
    </div>
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";

export default {
  name: "app",
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
  },
  components: {
    Navbar
  },
  methods: {
      updateUser(newUserObj) {
          console.log("we are updating user", newUserObj);
          this.user = newUserObj
      }
  }
};
</script>

<style lang="scss">
@import url('../public/css/normalize.css');
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400&display=fallback');
@import url('../public/fonts/platform.css');
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;300;400&display=fallback');

$blue:#0041ff;
$yellow:#FCB213;
$red:#FF113C;
$redAlt:#FF4040;
$slateGrey:#2c3e50;

body {
  font-family: Inter, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $slateGrey;
}

body.login {
    background: black;
    background-color: black;
    background-repeat: no-repeat;
    background-position: center bottom;
    background-image:url("/img/login-bg.png");
    background-size: 120%;
}

#app {
  max-width: 1140px;
  margin: auto;
}

h1 {
  font-size: 2.7em;
  font-family: "Poppins"
}

ul {
  margin: 0 0;
  padding: 0;
  list-style:none;
}
li {
  margin: 0.5em 0;
}
a, a:visited {
  color: inherit;
}
ul {
  margin: 0 0;
  padding: 0;
  list-style:none;
}
li {
  margin: 0.5em 0;
}

button {
  border: 1px solid $slateGrey;
  padding: 12px 22px;
  background-color: transparent;
  color: $slateGrey;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  outline: none;
  transition: background-color 0.2s ease-out,border 0.2s ease-out;
}
button a {
  text-decoration: none;
}

button:hover {
  background-color: $yellow;
  border: 1px solid $yellow;
}

.wrap {
  padding: 10px 40px;
}
.logo {
  font-family:"platform";
  font-weight: 800;
  font-size: 24px;
}
.grid {
  display: grid;  
}
.page {
  min-height: 60vh;
}
</style>
